import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import "./RequestQuote.css";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import SearchIcon from "@material-ui/icons/Search";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import DateRangeIcon from "@material-ui/icons/DateRange";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import Header from "../Shard/Navbar/Header";
import { Link } from "react-router-dom";
import LoadingAndUnLoading from "./LoadingAndUnLoading";
import ProjectDetails from "./ProjectDetails";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const RequestQuote = ({
  isShaw,
  setIsShaw,
  setModalOpen,
  setLoginModalOpen,
}) => {
  const classes = useStyles();
  const [loadingUnDetails, setLoadingUnDetails] = useState([1]);
  const [state, setState] = React.useState({
    Food: "",
    fullLoad: "",
    truckType: "",
    make: "",
    lessLoad: "",
    top: "",
    side: "",
    name: "hai",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  const hanldeIncrementLD = () => {
    setLoadingUnDetails((prv) => [...prv, 1]);
  };

  return (
    <div className="Request-a-Quote">
      <Header
        isShaw={isShaw}
        setIsShaw={setIsShaw}
        setLoginModalOpen={setLoginModalOpen}
        setModalOpen={setModalOpen}
      />

      <Container>
        <div className="requsetQuote" style={{ paddingTop: "95px" }}>
          <Box className={classes.quoteHeading}>
            <Box>
              <Typography variant="h6">Request a Quote</Typography>
            </Box>
            <Box>
              <Typography variant="h6">Load Calculater</Typography>
            </Box>
          </Box>
          <Container>
            <div style={{ padding: "30px 0" }}>
              <Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <TextField
                          id="standard-helperText"
                          label="Product Type"
                          defaultValue="Chemical"
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <TextField
                          id="standard-helperText"
                          label="Transportation Type"
                          defaultValue="FTL"
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <TextField
                          id="standard-helperText"
                          label="Packaging"
                          defaultValue="Bulk"
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <TextField
                          id="standard-helperText"
                          label="Ready to Load"
                          defaultValue="30/09/2022"
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon">
                      <Box>
                        <TextField
                          id="standard-helperText"
                          label="Truck Type"
                          defaultValue="20 feet comtainer"
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4}>
                    <Box className="quote_inputIcon bigLabel">
                      <Box>
                        <TextField
                          id="standard-helperText"
                          label="Estimated Delivery Date"
                          defaultValue="03/09/2022"
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </div>
          </Container>
          {/* <Box className={classes.quoteContent}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
                paddingBottom: "15px",
              }}
            >
              <Typography variant="span">
                <HomeIcon />
              </Typography>
              <Typography variant="h6">Product Type</Typography>
            </Box>
            <Container>
              <Box className="selector">
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel htmlFor="outlined-age-native-simple">
                    Food
                  </InputLabel>
                  <Select
                    native
                    value={state.Food}
                    onChange={handleChange}
                    label="Age"
                    inputProps={{
                      name: "Food",
                      id: "outlined-age-native-simple",
                    }}
                  >
                    <option aria-label="None" value="" />
                    <option value={"Food"}>Food</option>
                    <option value={20}>Twenty</option>
                    <option value={30}>Thirty</option>
                  </Select>
                </FormControl>
              </Box>
            </Container>
          </Box> */}
          {/* secound content */}
          {/*   <Box className={classes.quoteContent}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
                paddingBottom: "15px",
              }}
            >
              <Typography variant="span">
                <HomeIcon />
              </Typography>
              <Typography variant="h6">Transportation Type</Typography>
            </Box>
            <Container>
              <Box className={classes.quoteContainer}>
                <Box className="selector">
                  <Typography
                    variant="h5"
                    className={classes.title}
                    style={{ visibility: "hidden" }}
                  >
                    ffff
                  </Typography>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      Full Truck Load (FTL)
                    </InputLabel>
                    <Select
                      native
                      value={state.fullLoad}
                      onChange={handleChange}
                      label="Full Truck Load (FTL)"
                      inputProps={{
                        name: "fullLoad",
                        id: "outlined-age-native-simple",
                      }}
                    >
                      <option aria-label="None" value="" />
                      <option value="Truck Load">Full Truck Load (FTL)</option>
                      <option value={20}>Twenty</option>
                      <option value={30}>Thirty</option>
                    </Select>
                  </FormControl>
                </Box>
                <Box className="selector">
                  <Typography variant="h5" className={classes.title}>
                    Truck Type
                  </Typography>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      Container, Tanker etc
                    </InputLabel>
                    <Select
                      native
                      value={state.truckType}
                      onChange={handleChange}
                      label="Truck Type"
                      inputProps={{
                        name: "truckType",
                        id: "outlined-age-native-simple",
                      }}
                    >
                      <option aria-label="None" value="" />
                      <option value={"Container, Tanker etc"}>
                        Container, Tanker etc
                      </option>
                      <option value={20}>Twenty</option>
                      <option value={30}>Thirty</option>
                    </Select>
                  </FormControl>
                </Box>
                <Box className="selector">
                  <Typography variant="h5" className={classes.title}>
                    Make
                  </Typography>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      5
                    </InputLabel>
                    <Select
                      native
                      value={state.make}
                      onChange={handleChange}
                      label="Make"
                      inputProps={{
                        name: "make",
                        id: "outlined-age-native-simple",
                      }}
                    >
                      <option aria-label="None" value="" />
                      <option value={"MS/ SS/AI"}>MS/ SS/AI</option>
                      <option value={20}>Twenty</option>
                      <option value={30}>Thirty</option>
                    </Select>
                  </FormControl>
                </Box>
                <Box className="selector">
                  <Typography
                    variant="h5"
                    className={classes.title}
                    style={{ visibility: "hidden" }}
                  >
                    ffff
                  </Typography>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      Less Truck Load (LTL)
                    </InputLabel>
                    <Select
                      native
                      value={state.lessLoad}
                      onChange={handleChange}
                      label="Less Truck Load (LTL)"
                      inputProps={{
                        name: "lessLoad",
                        id: "outlined-age-native-simple",
                      }}
                    >
                      <option aria-label="None" value="" />
                      <option value={"Less Truck Load (LTL)"}>
                        Less Truck Load (LTL)
                      </option>
                      <option value={20}>Twenty</option>
                      <option value={30}>Thirty</option>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Container>
          </Box> */}

          {/*Loding and Unloading Details  */}
          {loadingUnDetails.map((_, i) => (
            <LoadingAndUnLoading
              hanldeIncrementLD={hanldeIncrementLD}
              key={i}
            />
          ))}

          {/* Ready to Load */}
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span>Ready to Load</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box className="loadinUnloadingInput">
                        <TextField
                          id="outlined-basic"
                          label="25/10/2022"
                          variant="outlined"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Unloading"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
          </Box>

          {/* Driver Requirements */}
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "10px",
                    paddingBottom: "15px",
                  }}
                >
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">Driver Requirements </Typography>
                </Box>
                <Container>
                  <Box className="">
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Training"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="PPE"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Entry Permits"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
          </Box>

          {/* Product Details */}

          <ProjectDetails />

          {/* Associated Service  */}
          <Box className={classes.quoteContent}>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Associated Service</span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={<Checkbox name="Loading" color="primary" />}
                        label="Insuracnce"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Certification"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Inspection Services"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Custom Clearance"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Entry Permits"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Required Equipment  */}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Required Equipment</span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Liftgate"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="PalletJack"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Load Straps"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Load bars"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="TIR Cable"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Side Loading"
                      />
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Pump"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Flow Meter"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Scully System"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Lash Belt"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Tarpaulin"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Remarks */}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={8} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Remarks</span>
                      </Typography>
                    </Box>
                    <Box className="request1Input">
                      {" "}
                      <TextField
                        id="outlined-basic"
                        label=""
                        variant="outlined"
                        className="request1Input"
                      />
                    </Box>
                    <Box className="quoteContentBtn">
                      <Link to="/dashboard">
                        <button className="common-btn common-btn1">
                          Save as Draft
                        </button>
                      </Link>
                      <button className="common-btn common-btn2">Submit</button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Container>
    </div>
  );
};

export default RequestQuote;
